import { UserRoleType, UserStatusType } from '@account_module/types/Organizations';

export const USER_ROLE_KEY = {
  admin: 'admin' as UserRoleType,
  editor: 'editor' as UserRoleType,
  viewer: 'viewer' as UserRoleType,
};

export const USER_STATUS_KEY = {
  activated: 'activated' as UserStatusType,
  invited: 'invited' as UserStatusType,
  expired: 'expired' as UserStatusType,
};
